import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getTypeListApiData,
  getTypeListApiSuccess,
  getTypeListApiFailed,
  getCategoryListApiData,
  getCategoryListApiSuccess,
  getCategoryListApiFailed,
  getSubCategoryListApiData,
  getSubCategoryListApiSuccess,
  getSubCategoryListApiFailed,
  getNearbyApiData,
  getNearbyApiSuccess,
  getNearbyApiFailed,
  getBannerApiData,
  getBannerApiSuccess,
  getBannerApiFailed,
} from './slice'
import { API } from 'src/main/services'

const isOk = (response) =>
  response?.status === 200 &&
  response?.data &&
  response?.data?.code === 0 &&
  response?.data?.error === false

function* getTypeList() {
  try {
    const response = yield call(API.bookCab.getTypeList)
    if (isOk(response)) {
      yield put(getTypeListApiSuccess({ data: response?.data?.data }))
    } else {
      yield put(getTypeListApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getTypeListApiFailed({ message: error?.message }))
  }
}

function* getCategoryList({ payload }) {
  try {
    const response = yield call(API.bookCab.getCategoryList, payload)
    if (isOk(response)) {
      yield put(getCategoryListApiSuccess({ data: response?.data?.data }))
    } else {
      yield put(getCategoryListApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getCategoryListApiFailed({ message: error?.message }))
  }
}

function* getSubCategoryList({ payload }) {
  try {
    const response = yield call(API.bookCab.getSubCategoryList, payload)
    if (isOk(response)) {
      yield put(getSubCategoryListApiSuccess({ data: response?.data?.data }))
    } else {
      yield put(getSubCategoryListApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getSubCategoryListApiFailed({ message: error?.message }))
  }
}

function* getNearby({ payload }) {
  try {
    const response = yield call(API.bookCab.getNearbyVehicles, payload)
    if (isOk(response)) {
      yield put(
        getNearbyApiSuccess({ data: response?.data?.data, total: response?.data?.total }),
      )
    } else {
      yield put(getNearbyApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getNearbyApiFailed({ message: error?.message }))
  }
}

function* getBanners() {
  try {
    const response = yield call(API.bookCab.getBanners)
    if (isOk(response)) {
      yield put(getBannerApiSuccess({ data: response?.data?.data }))
    } else {
      yield put(getBannerApiFailed())
    }
  } catch (error) {
    // A missing banner is cosmetic — never surface it as a page error.
    yield put(getBannerApiFailed())
  }
}

function* bookCabSaga() {
  yield takeLatest(getTypeListApiData, getTypeList)
  yield takeLatest(getCategoryListApiData, getCategoryList)
  yield takeLatest(getSubCategoryListApiData, getSubCategoryList)
  yield takeLatest(getNearbyApiData, getNearby)
  yield takeLatest(getBannerApiData, getBanners)
}

export default bookCabSaga
